<template>
  <div class="content">
    <div class="title-img">
      <img class="wenwu" src="../../../assets/wwjd-bj@2x.png" alt="">
<!--      <img class="logo" src="../../../assets/wwjd@2x.png" alt="">-->
    </div>
<!--    <div class="box1">-->
<!--      <router-link tag="div" class="tabBox" to="/culturalRelic/notice">-->
<!--        <img src="../../../assets/hdxz@2x.png" alt="">-->
<!--      </router-link>-->
<!--      <router-link tag="div" class="tabBox" to="/culturalRelic/promise">-->
<!--        <img src="../../../assets/cns@2x.png" alt="">-->
<!--      </router-link>-->
<!--    </div>-->
    <div class="box2">
<!--      <img :src="require('../../../assets/' + (tabIndex == 3 ? 'jdhd2@2x.png' : 'jdhd@2x.png'))"-->
<!--           @click="tabIndexClick(3)" alt="">-->
<!--      <img :src="require('../../../assets/' + (tabIndex == 0 ? 'hdhg2@2x.png' : 'hdhg@2x.png'))"-->
<!--           @click="tabIndexClick(0)" alt="">-->
      <div v-for="(item,index) in tab" @click="tabIndexClick(item.id,index)" :class="index == activeIndex ? 'active' : ''" :key="index">
        <img :src="item.img" alt="">
      </div>
    </div>
    <div class="culturalList">
      <van-empty
        v-if="listData.length == 0"
        class="custom-image"
        :image="require('@/assets/moren@2x.png')"
        description="活动尚未开始，敬请期待"
      />
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        @load="onReachBottom"
      >
        <div class="list" v-for="(item,index) in listData" :key="index" @click="ditile(item)">
          <img :src="item.coverImage" alt="">
          <div class="infos">
            <p>{{ item.name }}</p>
            <p>{{ item.location }}</p>
            <div v-if="tabIndex == 3">{{ item.activeStatus_dictText }}</div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { getActivityPageList, getBasicOne, getHistoryList } from '@/api/culturalRelic'

export default {
  name: 'culturaRelic',
  data () {
    return {
      loading: false,
      finished: false,
      listData: [],
      pageNo: 1,
      tabIndex: 3,
      tab: [
        {
          name: '鉴定活动',
          img: require('../../../assets/jdhd.png'),
          id: 3
        },
        {
          name: '精彩回顾',
          img: require('../../../assets/jchg.png'),
          id: 0
        }
      ],
      activeIndex: 0
    }
  },
  mounted () {
    this.ditileData()
    // this.culturalList()
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    tabIndexClick (val, index) {
      this.finished = false
      this.tabIndex = val
      this.activeIndex = index
      this.listData = []
      this.pageNo = 1
      if (this.tabIndex === 0) {
        this.HistoryList()
      } else {
        this.culturalList()
      }
    },
    ditile (item) {
      console.log(item.activeStatus)
      if (item.activeStatus !== 3) {
        if (this.tabIndex === 0) {
          sessionStorage.setItem('richText', JSON.stringify(item))
          this.$router.push('/culturalRelic/richText')
        } else {
          this.$router.push(`/culturalRelic/signUpNotice/${item.id}`)
        }
      }
    },
    async culturalList () {
      this.loading = true
      if (!this.finished) {
        const { result } = await getActivityPageList({
          // activeStatus: this.tabIndex,
          pageNo: this.pageNo++
        })
        this.loading = false
        if (this.listData.length === result.total) {
          this.finished = true
          return
        }
        this.listData = [...this.listData, ...result.records]
        this.timer && clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.finished = result.current === result.pages
          this.loading = false
        }, 100)
      }
    },
    async HistoryList () {
      this.loading = true
      if (!this.finished) {
        const { result } = await getHistoryList({
          pageNo: this.pageNo++
        })
        console.log(this.listData.length === result.total)
        this.loading = false
        if (this.listData.length === result.total) {
          this.finished = true
          return
        }
        this.listData = [...this.listData, ...result.records]
        this.timer && clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.finished = result.current === result.pages
          this.loading = false
        }, 100)
      }
    },
    async ditileData () {
      const { result } = await getBasicOne()
      sessionStorage.setItem('Notice', JSON.stringify(result))
    },
    onReachBottom () {
      // if (this.listData.length !== 0) {
      if (this.tabIndex === 0) {
        this.HistoryList()
      } else {
        this.culturalList()
      }
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  min-height: 100vh;
  background-color: #F9F0DE;

  .tabBox {
    display: inline-block;
    width: 46%;

    &:nth-child(1) {
      margin-right: 6%;
    }
  }

  .title-img {
    position: relative;
    margin-bottom: 18px;

    .wenwu {
      width: 100%;
      height: 337px;
    }

    .logo {
      position: absolute;
      top: 90px;
      left: 15px;
      width: 120px;
      height: 120px;
    }
  }

  .box1 {
    padding: 0 13px;
    box-sizing: border-box;

    img {
      width: 100%;
      display: inline-block;
      object-fit: cover;
    }
  }

  .box2 {
    padding: 0 20px;
    box-sizing: border-box;
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: center;
    div {
      display: inline-block;
      width: 143px;
      margin-right: 13px;
      opacity: .7;
      img {
        width: 100%;
      }
    }
    .active {
      opacity: 1;
    }
  }

  .culturalList {
    width: 100%;
    padding: 0 13px;
    box-sizing: border-box;
    ::v-deep .custom-image .van-empty__image {
      height: auto;
      img {
        width: 100%;
        height: auto;
      }
    }

    .list {
      position: relative;
      height: 200px;
      border-radius: 7px;
      overflow: hidden;
      margin-bottom: 10px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .infos {
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        padding: 20px;
        box-sizing: border-box;

        p {
          margin: 0;
          font-size: 14px;
          font-weight: 400;
          color: rgba(254, 248, 244, 0.5);

          &:nth-child(1) {
            width: 75%;
            margin-bottom: 10px;
            font-size: 18px;
            font-weight: bold;
            color: #FFFFFF;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        div {
          position: absolute;
          right: 30px;
          top: 30px;
          display: inline-block;
          padding: 6px 14px;
          box-sizing: border-box;
          background-color: rgba(255, 255, 255, .5);
          border-radius: 13px;
          font-size: 13px;
          color: #312925;
        }
      }
    }
  }
}
</style>
